<template>
  <div class="WireInquire">
    <b-container class="bv-example-row px-0">
      <b-row class="mx-0">
        <div style="width:100vw">
          <b-row class="mx-0 mb-3">
            <b-col cols="1"> </b-col>

            <b-col cols="10">
              <b-col
                cols="12"
                class="p-0 m-0 mt-4"
                style="font-size: 1.75rem; color: #000000"
              >
                <span class="m-auto">線材查詢</span>
              </b-col>
              <commonQueryIoT />
              <wireInquireResult />
            </b-col>
            <b-col cols="1"> </b-col>
          </b-row>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import commonQueryIoT from "@/components/commonQueryIoT.vue";
import wireInquireResult from "@/components/wireInquireResult.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "WireInquire",
  data() {
    return {};
  },
  created: function() {
    let vm = this;
    vm.change_selectPage("wireinquire");
    vm.change_selectPageName(vm.pageName.wireinquire);
    vm.setCommonQueryData();
    vm.setQueryInput();
  },
  mounted: function() {},
  components: {
    commonQueryIoT,
    wireInquireResult
  },
  watch: {
    commonQueryResponse: {
      handler() {
        let vm = this;
        if (
          vm.commonQueryResponse == "查無資料" ||
          vm.commonQueryResponse == "時間尚未選擇"
        ) {
          return;
        }
        vm.set_wireInquireResultItem(vm.commonQueryResponse[0]["wire_data"]);
        vm.set_wireInquireWorkCode(
          vm.commonQueryResponse[0]["query_work_code"]
        );
      }
    }
  },
  computed: {
    ...mapGetters({
      pageName: "getlogin/get_pageName",
      commonQueryResponse: "commonqueryiot/get_queryResponse"
    })
  },
  methods: {
    ...mapActions({
      change_selectPage: "getlogin/change_selectPage",
      change_selectPageName: "getlogin/change_selectPageName",
      set_phpfunction: "commonqueryiot/set_phpfunction",
      set_selectTag: "commonqueryiot/set_selectTag",
      set_selectTagCheck: "commonqueryiot/set_selectTagCheck",
      set_wireInquireResultItem: "wireInquireResult/set_wireInquireResultItem",
      set_wireInquireWorkCode: "wireInquireResult/set_wireInquireWorkCode",
      clear_wireInquireResultItem:
        "wireInquireResult/clear_wireInquireResultItem",
      clear_wireInquireWorkCode: "wireInquireResult/clear_wireInquireWorkCode"
    }),
    setCommonQueryData() {
      let vm = this;
      vm.set_phpfunction("wireInquire");
    },
    setQueryInput() {
      let vm = this;
      vm.set_selectTag({
        startTime: false,
        endTime: false,
        workCode: true
      });
      vm.set_selectTagCheck({
        startTime: false,
        endTime: false,
        process: false,
        deviceCode: false,
        productCode: false,
        workCode: true
      });
    },
    //資料reset
    reset(keep) {
      var def = this.$options.data();
      for (var i = 0; i < keep.length; i++) {
        def[keep[i]] = this[keep[i]];
      }
      Object.assign(this.$data, def);
      //https://codepen.io/karimcossutti/pen/ObXyKq
    }
  },
  destroyed() {
    let vm = this;
    vm.clear_wireInquireResultItem();
    vm.clear_wireInquireWorkCode();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
<style lang="scss"></style>



// WEBPACK FOOTER //
// src/views/WireInquire.vue